import { CategorizedListCategoryNamedId } from 'components/categorizedList/categorizedList.types';

/** The category titles. */
export const categoryTitles: Record<CategorizedListCategoryNamedId, string> = {
  favorite: 'Favorites',
  frequent: 'Frequently used',
  recent: 'Recently used',
  paginated: 'All',
};
